import { appraisalSurchargeCriteriaApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { formatReceivedCriteriaToFlat } from './appraisalSurchargeCriteria.utils';

export const APPRAISAL_SURCHARGE_CRITERIA_ACTION_TYPE = createNamedActions(
  'appraisalSurchargeCriteria',
  {
    GET_APPRAISAL_SURCHARGE_CRITERIA: 'GET_APPRAISAL_SURCHARGE_CRITERIA',
    CREATE_APPRAISAL_SURCHARGE_CRITERIA: 'CREATE_APPRAISAL_SURCHARGE_CRITERIA',
    EDIT_APPRAISAL_SURCHARGE_CRITERIA: 'EDIT_APPRAISAL_SURCHARGE_CRITERIA',
    DELETE_APPRAISAL_SURCHARGE_CRITERIA: 'DELETE_APPRAISAL_SURCHARGE_CRITERIA',
  },
);

export const getAppraisalSurchargeCriteriaAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await appraisalSurchargeCriteriaApi.getCriteria();
  const { criteria, companyId } = data || {};

  return dispatch({
    type: APPRAISAL_SURCHARGE_CRITERIA_ACTION_TYPE.GET_APPRAISAL_SURCHARGE_CRITERIA,
    payload: formatReceivedCriteriaToFlat(criteria, { companyId }),
  });
});

export const createAppraisalSurchargeCriteriaAction = catchAsyncActionError(
  body => async dispatch => {
    const { data } = await appraisalSurchargeCriteriaApi.createCriteria(body);
    const { criteria, companyId } = data || {};

    return dispatch({
      type: APPRAISAL_SURCHARGE_CRITERIA_ACTION_TYPE.CREATE_APPRAISAL_SURCHARGE_CRITERIA,
      payload: formatReceivedCriteriaToFlat(criteria, { companyId }),
    });
  },
);

export const editAppraisalSurchargeCriteriaAction = catchAsyncActionError(
  body => async dispatch => {
    const { data } = await appraisalSurchargeCriteriaApi.editCriteria(body);
    const { criteria, companyId } = data || {};

    return dispatch({
      type: APPRAISAL_SURCHARGE_CRITERIA_ACTION_TYPE.EDIT_APPRAISAL_SURCHARGE_CRITERIA,
      payload: formatReceivedCriteriaToFlat(criteria, { companyId }),
    });
  },
);

export const deleteAppraisalSurchargeCriteriaAction = catchAsyncActionError(
  ({ criteriaId }) =>
    async dispatch => {
      const { data } = await appraisalSurchargeCriteriaApi.deleteCriteria({ criteriaId });
      const { criteria, companyId } = data || {};

      return dispatch({
        type: APPRAISAL_SURCHARGE_CRITERIA_ACTION_TYPE.DELETE_APPRAISAL_SURCHARGE_CRITERIA,
        payload: formatReceivedCriteriaToFlat(criteria, { companyId }),
      });
    },
);
